import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignDonationModel } from 'src/app/shared/model/campaign-donation.model';
import {
  pledgeDonationModel,
  PledgePaymentModel,
} from 'src/app/shared/model/pledge-donation.model';
import { DonationService } from 'src/app/shared/services/donation/donation.service';
import { FundraiserService } from 'src/app/shared/services/fundraiser/fundraiser.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { PaymentMethodEnum } from 'src/app/shared/enum/payment-method.enum';
import { PledgingStatusTypeEnum } from 'src/app/shared/enum/pledging-status.enum';
@Component({
  selector: 'app-donation-summary-shared',
  templateUrl: './donation-summary-shared.component.html',
  styleUrl: './donation-summary-shared.component.scss',
})
export class DonationSummarySharedComponent {
  @Input() campaign: CampaignDonationModel = new CampaignDonationModel();
  @Input() donationSummary: any;
  @Input() ngo_id: string;
  @Input() project_id: string;
  @Input() campaign_id: string;
  @Input() isCampaignHasData: boolean;

  @Output() updateCampaign = new EventEmitter<void>();

  public sessionUser = this.localStorageService.getSessionUser();
  public selectedRole = this.localStorageService.getSelectedRole();
  public isAdmin: boolean =
    this.localStorageService.getSelectedRole().short_form === 'system_admin';

  public pledgeDonationModel: pledgeDonationModel = new pledgeDonationModel();
  public pledgePaymentModel: PledgePaymentModel = new PledgePaymentModel();

  public pledgeList: any[] = [];
  public pledgeListBoolean: boolean = false;
  // public allPledgeList: any[] = [];

  public paymentMethod: any[] = [
    PaymentMethodEnum.BankTransfer,
    PaymentMethodEnum.Bkash,
    PaymentMethodEnum.Nagad,
    PaymentMethodEnum.Rocket,
    PaymentMethodEnum.Cash,
  ];

  public donationList: any;

  private donationListFetched: boolean = false;
  public donationListPopUp = false;

  public currentDonationList: any;
  public activeFilter: string = 'recent';

  public activeTab: number = 0;
  public pledgeListPopup: boolean = false;
  public pledgeDetailsPopup: boolean = false;
  public isSuccessful: boolean = false;
  public rejected: boolean = false;
  public pledgeDetails: any = null;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly donationService: DonationService,
    private readonly utilitiesService: UtilitiesService,
    private readonly fundraiserService: FundraiserService,
    private readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    // this.getPledgeByCampaign();
    console.log(this.donationSummary);
  }

  // public getAllPledges() {
  //   this.donationService.getAllPledgeDonation().subscribe({
  //     next: (result) => {
  //       this.allPledgeList = result;
  //     },
  //     error: (err) => {
  //       console.log(err);
  //     },
  //   });
  // }

  public getPledgeByCampaign() {
    this.donationService.getAllPledgeByCampaignId(this.campaign_id).subscribe({
      next: (result) => {
        this.pledgeList = result.sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
        if (this.activeTab === 1) {
          this.filterPledgedStatus();
        } else {
          this.filterDonatedStatus();
        }
        // .filter((pledgeList) => pledgeList?.pledging_status !== 'DONATED');
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  public filterDonatedStatus() {
    this.pledgeList = this.pledgeList.filter(
      (pledgeList) => pledgeList?.pledging_status === 'DONATED'
    );
  }

  public filterPledgedStatus() {
    this.pledgeList = this.pledgeList.filter(
      (pledgeList) => pledgeList?.pledging_status !== 'DONATED'
    );
  }

  public seeAll() {
    this.donationListPopUp = true;
    if (!this.donationListFetched) {
      this.donationService
        .getDonationListByCampaign(
          this.ngo_id,
          this.project_id,
          this.campaign_id
        )
        .subscribe({
          next: (result) => {
            this.donationListSuccess(result);
          },
          error: (err) => {},
        });
    } else {
      this.filterDonations('recent');
    }
  }

  public closePopup() {
    this.donationListPopUp = false;
  }

  public closePledgePopup() {
    this.pledgeListPopup = false;
  }
  public closePledgeDetailsPopup() {
    this.pledgeDetailsPopup = false;
  }

  public pledgePopHiding() {
    this.pledgeListPopup = false;
    this.activeTab = 0;
  }

  public pledgeDetailsPop(item: any) {
    this.pledgeDetails = item;
    this.pledgeListPopup = false;
    this.pledgeDetailsPopup = true;
  }

  public backToList() {
    this.pledgeDetailsPopup = false;
    this.pledgeListPopup = true;
  }

  public rejectPopup() {
    this.pledgeDetailsPopup = false;
    this.rejected = true;
  }
  public confirmPopUp() {
    const { isValid } = ValidationEngine.validateGroup('pledgeValidationGrp');
    if (isValid) {
      this.pledgeDetailsPopup = false;
      this.isSuccessful = true;
    }
  }

  public cancelSuccessPopup() {
    this.pledgePaymentModel = new PledgePaymentModel();
    this.isSuccessful = false;
  }

  public confirmPledgeFunc() {
    this.isSuccessful = false;
    this.updatePledge(this.pledgeDetails.id, PledgingStatusTypeEnum.PLEDGED);
  }

  public confirmRejectPopup() {
    this.updatePledge(
      this.pledgeDetails.id,
      PledgingStatusTypeEnum.PLEDGE_DENIED
    );
    this.rejected = false;
  }

  public updatePledge(id: string, status: string) {
    this.pledgePaymentModel = new PledgePaymentModel({
      received_amount:
        status === PledgingStatusTypeEnum.PLEDGED
          ? this.pledgePaymentModel.received_amount
          : 0,
      payment_method:
        status === PledgingStatusTypeEnum.PLEDGED
          ? this.pledgePaymentModel.payment_method
          : null,
      pledging_status: status,
      transaction_id:
        status === PledgingStatusTypeEnum.PLEDGED
          ? this.pledgePaymentModel.transaction_id
          : null,
      admin_id:
        this.localStorageService.getSelectedRole().short_form === 'admin'
          ? this.sessionUser.id
          : null,
    });
    this.donationService
      .confirmPledgeDonation(id, this.pledgePaymentModel)
      .subscribe({
        next: (result) => {
          this.pledgePaymentModel = new PledgePaymentModel();
          this.isSuccessful = false;
          ValidationEngine.resetGroup('pledgeValidationGrp');
          this.updateCampaign.emit();
          this.getPledgeByCampaign();
        },
        error: (err) => {
          this.isSuccessful = false;
        },
      });
  }

  public cancelRejectPopup() {
    this.rejected = false;
  }

  private donationListSuccess(result: any) {
    this.donationList = result?.donations;
    this.donationListFetched = true;
    this.filterDonations('recent');
  }

  public filterDonations(type: 'recent' | 'top') {
    this.activeFilter = type;
    if (type === 'recent') {
      this.currentDonationList = this.donationList.sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    } else if (type === 'top') {
      this.currentDonationList = this.donationList.sort(
        (a, b) => b.amount - a.amount
      );
    }
  }

  public getDonationTime(createdAt: string): string {
    const donationDate = new Date(createdAt);
    const currentDate = new Date();
    const timeDiffInMs = currentDate.getTime() - donationDate.getTime();
    const hours = Math.floor(timeDiffInMs / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''}`;
    } else {
      return `${hours + 1} hour${hours > 1 ? 's' : ''}`;
    }
  }

  public navigateToCampaignDonation(campaign: any): void {
    const encryptedParams = this.localStorageService.encryptObjectUrl({
      id: campaign.id,
      ngo_id: campaign?.ngo_id,
      project_id: campaign?.project_id,
    });
    this.router.navigate(['/donate-to-campaign'], {
      queryParams: { data: encryptedParams },
    });
  }

  public onTabChange(event: any) {
    this.activeTab = event.component.option('selectedIndex');
    this.getPledgeByCampaign();
  }

  public onTabClick(event: any) {
    const target = event.target as HTMLElement;
    if (
      target &&
      (target.textContent?.trim() === 'Pledging' ||
        target.textContent?.trim() === 'Donation')
    ) {
      if (!this.pledgeListBoolean) {
        this.pledgeListBoolean = true;
        this.getPledgeByCampaign();
      }
      this.popUpOpening();
    }
  }

  public popUpOpening() {
    this.pledgeListPopup = true;
  }

  public onPaymentMethodChange(selectedMethod: string): void {
    this.pledgePaymentModel.payment_method = selectedMethod;
  }
}
